import { render, staticRenderFns } from "./NotificationNewMetadataDialog.vue?vue&type=template&id=6c7a5014&scoped=true&"
import script from "./NotificationNewMetadataDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationNewMetadataDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationNewMetadataDialog.vue?vue&type=style&index=0&id=6c7a5014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a5014",
  null
  
)

export default component.exports